import { Link, useParams } from "react-router-dom";
import BookBlogArticlePage from "../components/BookBlogArticlePage";
import { BOOK_BLOG_POSTS, BOOK_BLOG_ARTICLES } from "../data/bookBlogContent";

const BookBlogArticle = () => {
  const { slug } = useParams();
  const post = BOOK_BLOG_POSTS.find((p) => p.slug === slug);
  const article = BOOK_BLOG_ARTICLES[slug];

  if (!post || !article) {
    return (
      <div
        className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
        style={{ background: "var(--bg)", color: "var(--text)" }}
      >
        <h1 className="font-serif text-3xl mb-4">Post not found</h1>
        <Link
          to="/book-blog"
          className="text-sm px-5 py-2.5 rounded-full border"
          style={{ borderColor: "var(--border)", color: "var(--brand)" }}
        >
          Back to book blog
        </Link>
      </div>
    );
  }

  return <BookBlogArticlePage post={post} article={article} />;
};

export default BookBlogArticle;
